import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import theme from 'theme';
import { PASSWORD_STRENGTH__PASSWORDS_MATCH, PASSWORD_STRENGTH__PASSWORDS_NOT_MATCH } from 'translations/constants';
import { ReactComponent as CheckIcon } from '../../assets/icons/CheckIcon.svg';
import { PasswordsMatchTextContainer } from './styles';

type PasswordsMatchTextProps = {
  passwordsMatch: boolean;
};

const PasswordsMatchText = ({ passwordsMatch }: PasswordsMatchTextProps) => {
  const [t] = useTranslation();

  return (
    <PasswordsMatchTextContainer>
      {passwordsMatch && <CheckIcon />}
      <Typography fontSize={12} color={passwordsMatch ? theme.palette.primary.main : theme.palette.error.main}>
        {passwordsMatch ? t(PASSWORD_STRENGTH__PASSWORDS_MATCH) : t(PASSWORD_STRENGTH__PASSWORDS_NOT_MATCH)}
      </Typography>
    </PasswordsMatchTextContainer>
  );
};

export default PasswordsMatchText;
